import React from "react"
import { View, As } from "@design-system/core"

import { ViewLinkProps } from "./types"
import { useLink } from "./useLink"

export const ViewLink = React.forwardRef(
  (props: ViewLinkProps, ref: React.Ref<any>) => {
    const linkProps = useLink(props)
    let as = props.as
    if (!as && linkProps.href) {
      as = "a"
    }

    return <View {...linkProps} as={as} ref={ref} />
  },
)
